export default __webpack_public_path__ + "static/media/illus10.b2986824.png";